import { defineComponent as _defineComponent } from 'vue'
interface Props {
  isFiltersOpen?: boolean;
}
interface Emits {
  (e: 'toggle-filters'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogFilterHeaderFilters',
  props: {
    isFiltersOpen: { type: Boolean, default: false }
  },
  emits: ["toggle-filters"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggle-filters'): void;
}), expose: any, slots: any, attrs: any }) {




const toggleFilters = () => {
  emit('toggle-filters');
};

return { __sfc: true,emit, toggleFilters }
}

})